/* eslint-disable */
export default {
  copyToClipboard: '複製到剪貼簿',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
